import React, { useEffect, useState } from 'react';
import { OutsideClick } from '../../../../components/outside-click';
import { Formik } from 'formik';
import { EditAnnouncementVSchema } from './schema/edit-announcement-v-schema';
import {
  useEditAnnouncementMutation,
  useGetAnnouncementQuery,
} from '../../../../slices/announcementApiSlice';
import ModalContent from '../../../../components/modal-content';
import { Navigate } from 'react-router';

const EditAnnouncement = () => {
  const { data, isLoading } = useGetAnnouncementQuery('');
  const [submitEditAnnouncement, { isLoading: createIsLoading, isSuccess: createIsSuccess }] =
    useEditAnnouncementMutation();
  const initialValues = data?.[0] || { content: '' };

  const handleSubmit = (values: any) => {
    const data = { ...values };
    submitEditAnnouncement(data);
  };

  const formInputs = [
    {
      mainTitle: 'Announcement',
      name: 'content',
      label: 'Information',
      type: 'textarea',
      placeholder: 'Enter information',
      isTrue: true,
    },
  ];
  const editSeasonSchema = EditAnnouncementVSchema();
  if (createIsSuccess) return <Navigate to='../' />;
  return (
    <>
      <OutsideClick />
      <Formik
        validationSchema={editSeasonSchema}
        initialValues={{ ...initialValues }}
        onSubmit={handleSubmit}
      >
        {({ values, errors }) => {
          return (
            <>
              <ModalContent
                errors={Object.keys(errors).length}
                formInputs={formInputs}
                isLoading={createIsLoading}
                name='Edit Announcement'
              />
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default EditAnnouncement;
